/**
 * Created by alberto on 2014-11-28.
 */
define('payment/handlers/paymentMethodHandlers/paymentMethodHandlers',['jquery', 'payment/handlers/paymentMethodHandlers/siruMethodHandler', 'payment/handlers/paymentMethodHandlers/trustlyWithdrawMethodHandler', 'payment/handlers/paymentMethodHandlers/creditCardMethodHandler', 'payment/handlers/paymentMethodHandlers/eproCreditCardMethodHandler' ],

    function($, siruMethodHandler, trustlyWithdrawMethodHandler, creditCardMethodHandler, eproCreditCardMethodHandler) {
        'use strict';

        var depositHandlers = {
            'Siru' : siruMethodHandler,
            'Credit Card' : creditCardMethodHandler,
			'EPRO Credit Card' : eproCreditCardMethodHandler
        };

        var withdrawHandlers = {
            'Trustly': trustlyWithdrawMethodHandler
        };

        function setupDepositFormTemplate(methodName, depositBox) {
            var eventHandler = depositHandlers[methodName];
            setupFormTemplate(eventHandler, depositBox);
        }

        function setupWithdrawFormTemplate(methodName, withdrawBox) {
            var eventHandler = withdrawHandlers[methodName];
            setupFormTemplate(eventHandler, withdrawBox);
        }

        function setupFormTemplate(eventHandler, paymentBox){
            if (!eventHandler) {
                return;
            }
            eventHandler.setupFormTemplate(paymentBox);
        }

        var paymentMethodHandlers = {};
        paymentMethodHandlers.setupDepositFormTemplate = setupDepositFormTemplate;
        paymentMethodHandlers.setupWithdrawFormTemplate = setupWithdrawFormTemplate;

        return paymentMethodHandlers;
    }
);

